import { Fragment } from 'react/jsx-runtime'
import { useMediaQuery } from 'react-responsive'
import { Outlet } from 'react-router'

import { AstraMainLayout, AstraPrivacyModeProvider } from '~/astra'
import { DefaultCommandPalette } from '~/components/CommandPalette'
import { CommandPaletteProvider } from '~/components/CommandPalette/CommandPaletteContext'
import { DialogRouter } from '~/components/DialogRouter/DialogRouter'
import { DialogRouterProvider } from '~/components/DialogRouter/DialogRouterContext'
import { useFlag } from '~/hooks/useFlag'
import { useStore } from '~/store/store'

import { Navigation } from './Navigation'

export const MainLayout = () => {
    const { setIsNavSidebarOpen } = useStore(state => state.app.actions)
    const isPrivacyMode = useStore(state => state.app.isPrivacyMode)

    const isCommandPaletteEnabled = useFlag('command_palette')
    const privacyKey = isPrivacyMode ? 'privacy-mode-on' : 'privacy-mode-off'

    useMediaQuery(
        {
            query: '(max-width: 1224px)',
        },
        undefined,
        isMobile => {
            setIsNavSidebarOpen(!isMobile)
        }
    )

    return (
        <DialogRouterProvider>
            <CommandPaletteProvider>
                <AstraPrivacyModeProvider value={isPrivacyMode}>
                    <Fragment key={privacyKey}>
                        <AstraMainLayout navigation={<Navigation />}>
                            <Outlet />
                        </AstraMainLayout>
                        {isCommandPaletteEnabled && <DefaultCommandPalette />}
                        <DialogRouter />
                    </Fragment>
                </AstraPrivacyModeProvider>
            </CommandPaletteProvider>
        </DialogRouterProvider>
    )
}
